const text_cut = () => {
    
    var text = $(".more")
    
// Configure/customize these variables.
    var showChar = 640;  // How many characters are shown by default
    var ellipsestext = ""; // "..."
    var moretext = "Czytaj więcej";
    var lesstext = "Zwiń";
    

    text.each(function() {
        var content = $(this).html();
        var indexCut = content.indexOf('</p>')
                    
        if (indexCut > 0) {
            showChar = indexCut + 4;
        }
 
        if(content.length > showChar) {
 
            var c = content.substr(0, showChar);
            var h = content.substr(showChar, content.length - showChar);
 
            var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<div class="more-btn"><a href="#" class="morelink-home read-more"><span>' + moretext + '</span><i class="icon-arrow"></i></a></div></span>';
 
            $(this).html(html);
        }
 
    });
 
    $(".morelink-home").click(function(){
        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).find('span').html(moretext);
        } else {
            $(this).addClass("less");
            $(this).find('span').html(lesstext);
        }
        $(this).parent().parent().prev().toggle();
        $(this).parent().prev().toggle();
        return false;
    });
}

module.exports = {
    text_cut
};